import React from 'react'
import PropTypes from 'prop-types'
import {formatInt} from '../../helpers/format'
import {ALLOCATION_OVERSHOOT_WARN} from '../../constants'

/**
 * Dòng tóm tắt đối chiếu mục tiêu ↔ thực tế — FR-M17-20 bước 1, 2 và 2b.
 *
 * Bốn con số LUÔN hiện, kể cả khi mọi tỷ lệ là 100% và chúng bằng nhau (BR-N3-14): người dùng cần
 * thấy chúng bằng nhau thì mới tin phần còn lại của báo cáo. Ẩn đi khi "không có gì bất thường" là
 * đúng kiểu tiết kiệm làm mất niềm tin.
 *
 * Bấm được để mở tab Phân bổ theo mức khẩn (FR-M17-20 bước 3).
 */
function AllocationSummaryLine({totals, onOpenDetail}) {
    const {total, target, actual, pulled, pulledZero, roundUp} = totals
    const overshoot = target > 0 ? (actual - target) / target : 0
    const warn = overshoot > ALLOCATION_OVERSHOOT_WARN

    return (
        <div
            className={`VcAllocSummary ${warn ? 'VcAllocSummary--warn' : ''}`}
            role="button"
            tabIndex={0}
            onClick={onOpenDetail}
            onKeyPress={(event) => {
                if (event.key === 'Enter' || event.key === ' ') onOpenDetail()
            }}
        >
            <div className="VcAllocSummary__line">
                Sản lượng hiện tại <b>{formatInt(total)}</b> item · số lượng mục tiêu{' '}
                <b>{formatInt(target)}</b> · số lượng thực tế đưa vào tính <b>{formatInt(actual)}</b> ·
                kéo thêm do lấy trọn đơn <b>{formatInt(pulled)}</b>
            </div>

            {actual === target ? (
                <div className="VcAllocSummary__note">
                    Mọi cột đang đặt 100% nên ba con số bằng nhau.
                </div>
            ) : (
                <div className="VcAllocSummary__note">
                    Chênh lệch đến từ ba nguồn: làm tròn lên ở từng ô (+{formatInt(roundUp)}) · lấy nốt
                    item trong cùng ô · kéo thêm item ngoài ô do lấy trọn đơn (+{formatInt(pulled)}).
                    {/*
                      * Bắt buộc, không phải tuỳ chọn (FR-M17-20 bước 2b, R-N3-03). Người dùng đặt một
                      * cột về 0% là đang phát ra một ý định rõ ràng; hệ thống làm ngược lại ý định đó
                      * vì nguyên tắc trọn đơn, nên phải nói ra thành lời chứ không được im lặng —
                      * nếu không họ sẽ coi là lỗi hệ thống.
                      */}
                    {pulledZero > 0 && (
                        <div className="VcAllocSummary__zero">
                            Trong đó <b>{formatInt(pulledZero)} item thuộc các cột đang đặt 0%</b>, được
                            kéo vào do nằm chung đơn với item đã chọn.
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

AllocationSummaryLine.propTypes = {
    totals: PropTypes.shape({
        total: PropTypes.number.isRequired,
        target: PropTypes.number.isRequired,
        actual: PropTypes.number.isRequired,
        pulled: PropTypes.number.isRequired,
        pulledZero: PropTypes.number.isRequired,
        roundUp: PropTypes.number.isRequired,
    }).isRequired,
    onOpenDetail: PropTypes.func.isRequired,
}

export default AllocationSummaryLine
